module.exports = __webpack_public_path__ + "img/ziad_rashad.fe7ffe7a.webp";